import istor from '../Assets/istor2.png';
import ministor from '../Assets/ministor.png';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EyeOff, EyeOn } from '../PasswordEye';
import { useMediaQuery } from '../useMediaQuery';

const inputStyle = {
    width: '100%',
    height: '36px',
    borderRadius: '10px',
    padding: '0 15px',
    fontSize: '13px',
    fontWeight: '400',
    backgroundColor: '#FFFFFF',
    boxSizing: 'border-box',
};

const eyeBtnStyle = {
    position: 'absolute',
    top: '50%',
    right: '8px',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    width: '20px',
    height: '20px',
};

const buttonStyle = {
    width: '100%',
    height: '36px',
    borderRadius: '10px',
    color: '#FFFFFF',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
};

const RULES = [
    { label: 'Au moins 8 caractères',        test: (p) => p.length >= 8 },
    { label: 'Au moins 1 majuscule',         test: (p) => /[A-Z]/.test(p) },
    { label: 'Au moins 1 minuscule',         test: (p) => /[a-z]/.test(p) },
    { label: 'Au moins 1 caractère spécial', test: (p) => /\W/.test(p) },
    { label: 'Au moins 1 nombre',            test: (p) => /\d/.test(p) },
];

// Faux placeholder avec astérisque rouge (le placeholder natif ne peut pas colorer le « * »).
// Affiché tant que le champ est vide, par-dessus l'input.
const placeholderOverlayStyle = {
    position: 'absolute',
    top: '50%',
    left: '15px',
    transform: 'translateY(-50%)',
    display: 'flex',
    gap: '2px',
    pointerEvents: 'none',
    fontSize: '13px',
    fontWeight: '400',
    color: '#707070',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};

const RequiredPlaceholder = ({ show, text, right = '15px' }) => show ? (
    <div style={{ ...placeholderOverlayStyle, right }}>
        <span>{text}</span>
        <span style={{ color: '#F46969' }}>*</span>
    </div>
) : null;

// Flèche circulaire du bouton retour (réutilisée par « Revenir à la connexion » et « Retour »).
const RetourArrow = () => (
    <span className="retour-circle"><svg style={{ minWidth: '20px' }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask-retour-register" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
            <rect x="20" y="20" width="20" height="20" transform="rotate(-180 20 20)" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask-retour-register)">
            <path d="M6.5 10L12.453 4L13.5 5.07713L8.61571 10L13.5 14.9229L12.453 16L6.5 10Z" fill="currentColor"/>
        </g>
    </svg></span>
);

// Icône info « ? » de la ligne newsletter.
const InfoIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="8" fill="#173C50"/>
        <path d="M7.09375 9.60156V9.46875C7.09635 9.01302 7.13672 8.64974 7.21484 8.37891C7.29557 8.10807 7.41276 7.88932 7.56641 7.72266C7.72005 7.55599 7.90495 7.40495 8.12109 7.26953C8.28255 7.16536 8.42708 7.05729 8.55469 6.94531C8.68229 6.83333 8.78385 6.70964 8.85938 6.57422C8.9349 6.4362 8.97266 6.28255 8.97266 6.11328C8.97266 5.93359 8.92969 5.77604 8.84375 5.64062C8.75781 5.50521 8.64193 5.40104 8.49609 5.32812C8.35286 5.25521 8.19401 5.21875 8.01953 5.21875C7.85026 5.21875 7.6901 5.25651 7.53906 5.33203C7.38802 5.40495 7.26432 5.51432 7.16797 5.66016C7.07161 5.80339 7.01953 5.98177 7.01172 6.19531H5.41797C5.43099 5.67448 5.55599 5.24479 5.79297 4.90625C6.02995 4.5651 6.34375 4.3112 6.73437 4.14453C7.125 3.97526 7.55599 3.89062 8.02734 3.89062C8.54557 3.89062 9.00391 3.97656 9.40234 4.14844C9.80078 4.31771 10.1133 4.5638 10.3398 4.88672C10.5664 5.20964 10.6797 5.59896 10.6797 6.05469C10.6797 6.35937 10.6289 6.63021 10.5273 6.86719C10.4284 7.10156 10.2891 7.3099 10.1094 7.49219C9.92969 7.67187 9.71745 7.83464 9.47266 7.98047C9.26693 8.10286 9.09766 8.23047 8.96484 8.36328C8.83464 8.49609 8.73698 8.64974 8.67188 8.82422C8.60938 8.9987 8.57682 9.21354 8.57422 9.46875V9.60156H7.09375ZM7.86719 12.1016C7.60677 12.1016 7.38411 12.0104 7.19922 11.8281C7.01693 11.6432 6.92708 11.4219 6.92969 11.1641C6.92708 10.9089 7.01693 10.6901 7.19922 10.5078C7.38411 10.3255 7.60677 10.2344 7.86719 10.2344C8.11458 10.2344 8.33203 10.3255 8.51953 10.5078C8.70703 10.6901 8.80208 10.9089 8.80469 11.1641C8.80208 11.3359 8.75651 11.4935 8.66797 11.6367C8.58203 11.7773 8.46875 11.8906 8.32812 11.9766C8.1875 12.0599 8.03385 12.1016 7.86719 12.1016Z" fill="white"/>
    </svg>
);

const MOBILE_TITLE = '“Bonne idée !';
const MOBILE_SHORT = 'Je suis ravi de vous accueillir.”';

const Register = () => {
    const API_BASE_URL = 'https://dev-auth.apps.istor.io';

    const CONTENTS = {
        DEFAULT: {
            title: '”Excellente idée !',
            message: 'Je suis ravi de vous accueillir.\n' +
                'En créant votre compte Istor.io, vous \nprofiterez d’une expérience personalisée, en \nma compagnie, afin de découvrir et faire \ndécouvrir les ressources culturelles autour \nde vous.”',
        },
        MISSING_FIELDS: {
            title: '”Attention !',
            message: 'Vous avez, semble-t-il, oublié de remplir \nun champ obligatoire. Vous voyez, ceux \navec un astérisque rouge juste à côté.”',
        },
        EMAIL_USED: {
            title: '”Curieux...',
            message: 'Je vois dans mes miscellanées que votre \ncompte existe déjà. Avez-vous essayé de \nvous connecter ?”',
        },
        ERROR: {
            title: '”Oups...',
            message: 'Il semble qu’il y ait une erreur.\nVérifiez vos informations\net réessayez.”',
        },
    };

    const [step, setStep] = useState(0);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [error, setError] = useState(null);
    const [prenom, setPrenom] = useState('');
    const [nom, setNom] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [cgu, setCgu] = useState(false);
    const [newsletter, setNewsletter] = useState(false);
    const [loading, setLoading] = useState(false);
    const isMobile = useMediaQuery('(max-width: 750px)');
    const navigate = useNavigate();

    const istorContent = CONTENTS[error] ?? CONTENTS.DEFAULT;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        // Étape 1 : identité → passe à l'étape mot de passe.
        if (step === 0) {
            if (!prenom.trim() || !nom.trim() || !email.trim()) {
                setError('MISSING_FIELDS');
                return;
            }
            setStep(1);
            return;
        }

        // Étape 2 : mot de passe + CGU → création du compte.
        if (!password || !confirm || !cgu) {
            setError('MISSING_FIELDS');
            return;
        }

        if (!RULES.every((r) => r.test(password))) {
            setError('PASSWORD');
            return;
        }

        if (password !== confirm) {
            setError('MISMATCH');
            return;
        }

        setLoading(true);
        try {
            const res = await fetch(`${API_BASE_URL}/user`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ nom, prenom, email, password }),
            });

            if (!res.ok) {
                setError(res.status >= 500 ? 'EMAIL_USED' : 'GENERIC');
                setLoading(false);
                return;
            }

            const loginRes = await fetch(`${API_BASE_URL}/auth/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password }),
            });

            if (!loginRes.ok) {
                navigate('/');
                return;
            }

            const loginData = await loginRes.json();
            const accessToken = loginData?.accessToken;
            const refreshToken = loginData?.refreshToken;

            if (accessToken) {
                document.cookie = `jwt=${encodeURIComponent(accessToken)};Domain=.istor.io;Path=/;Max-Age=3600;SameSite=None;Secure`;
                document.cookie = `refreshJwt=${encodeURIComponent(refreshToken)};Domain=.istor.io;Path=/;Max-Age=86400;SameSite=None;Secure`;
            }

            window.location.href = '/';
        } catch {
            setError('GENERIC');
            setLoading(false);
        }
    };

    const passwordOk = RULES.every((r) => r.test(password));

    // --- Éléments réutilisables (desktop + mobile) ---

    const backLink = step === 0 ? (
        <a href="/" className="retour"><RetourArrow /> Revenir à la connexion</a>
    ) : (
        <button
            type="button"
            className="retour"
            onClick={() => { setError(null); setStep(0); }}
            style={{ background: 'transparent', border: 'none', padding: 0, cursor: 'pointer' }}
        >
            <RetourArrow /> Retour
        </button>
    );

    const textField = (value, setValue, placeholder, type = 'text') => (
        <div style={{ position: 'relative', width: '100%' }}>
            <input
                className="ifield"
                style={inputStyle}
                type={type}
                placeholder=""
                value={value}
                onChange={(e) => setValue(e.target.value)}
                required
            />
            <RequiredPlaceholder show={!value} text={placeholder} />
        </div>
    );

    const passwordField = (
        <div style={{ position: 'relative', width: '100%' }}>
            <button
                type="button"
                className="eye-toggle"
                onClick={() => setShowPassword((p) => !p)}
                style={eyeBtnStyle}
                aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
            >
                {showPassword ? <EyeOff /> : <EyeOn />}
            </button>
            <input
                className="ifield"
                style={{ ...inputStyle, paddingRight: '36px' }}
                type={showPassword ? 'text' : 'password'}
                placeholder=""
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
            />
            <RequiredPlaceholder show={!password} text="Entrez votre mot de passe" right="40px" />
        </div>
    );

    const rulesList = (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {RULES.map((r) => (
                <div key={r.label} style={{ fontSize: '10px', fontWeight: '400', color: r.test(password) ? '#67C856' : '#F46969', lineHeight: '1.4' }}>
                    {r.label}
                </div>
            ))}
        </div>
    );

    // Confirmation + indicateur : masqué et inactif tant que le mot de passe n'est pas valide.
    const confirmCombo = (
        <div
            aria-hidden={!passwordOk}
            style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                opacity: passwordOk ? 1 : 0,
                pointerEvents: passwordOk ? 'auto' : 'none',
                userSelect: passwordOk ? 'auto' : 'none',
                transition: 'opacity 0.2s ease',
            }}
        >
            <div style={{ position: 'relative', width: '100%' }}>
                <button
                    type="button"
                    className="eye-toggle"
                    onClick={() => setShowConfirm((p) => !p)}
                    style={eyeBtnStyle}
                    tabIndex={passwordOk ? 0 : -1}
                    aria-label={showConfirm ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                >
                    {showConfirm ? <EyeOff /> : <EyeOn />}
                </button>
                <input
                    className="ifield"
                    style={{ ...inputStyle, paddingRight: '36px' }}
                    type={showConfirm ? 'text' : 'password'}
                    placeholder=""
                    autoComplete="new-password"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    required={passwordOk}
                    tabIndex={passwordOk ? 0 : -1}
                />
                <RequiredPlaceholder show={!confirm} text="Confirmez votre mot de passe" right="40px" />
            </div>
            <div style={{ marginTop: '10px', width: '100%', fontSize: '10px', fontWeight: '400', color: password === confirm ? '#67C856' : '#F46969', lineHeight: '1.4' }}>
                {password === confirm ? 'Le mot de passe est identique' : 'Le mot de passe n’est pas identique'}
            </div>
        </div>
    );

    const cguRow = (
        <div style={{ display: 'flex', width: '100%', alignItems: 'center', gap: '8px', fontWeight: '300', fontSize: '11px', color: '#7C7C7D' }}>
            <input type="checkbox" checked={cgu} onChange={(e) => setCgu(e.target.checked)} />
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px' }}>
                J’accepte les <a style={{ fontWeight: '300', fontSize: '11px', color: '#007BD3', textDecoration: 'none', padding: 0, margin: 0 }} href="/">CGU</a><span style={{ color: '#F46969', fontSize: '13px' }}>*</span>
            </div>
        </div>
    );

    const newsletterRow = (
        <div style={{ display: 'flex', width: '100%', alignItems: 'center', gap: '8px', fontWeight: '300', fontSize: '11px', color: '#7C7C7D' }}>
            <input type="checkbox" checked={newsletter} onChange={(e) => setNewsletter(e.target.checked)} />
            J’accepte de recevoir les actualités istor.io
            <InfoIcon />
        </div>
    );

    const suivantBtn = <button className="connexion" type="submit" style={buttonStyle}>Suivant</button>;

    const cestPartiBtn = (
        <button
            className="connexion"
            type="submit"
            disabled={loading}
            style={{ ...buttonStyle, cursor: loading ? 'default' : 'pointer', opacity: loading ? 0.6 : 1 }}
        >
            C’est parti !
        </button>
    );

    // --- Rendu mobile (330×517) ---
    if (isMobile) {
        return (
            <form
                onSubmit={handleSubmit}
                style={{
                    width: '330px',
                    height: '517px',
                    maxHeight: 'calc(100dvh - 40px)',
                    boxSizing: 'border-box',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '20px',
                    boxShadow: '0px 10px 40px rgba(0, 0, 0, 0.1)',
                    padding: '20px 30px 30px 30px',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {/* Haut : mini-mascotte + titre + texte court, aligné à gauche */}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flexShrink: 0 }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                        <img src={ministor} alt="istor" style={{ width: '60px', height: '60px', borderRadius: '50%', flexShrink: 0 }}/>
                        <div style={{ fontSize: '24px', fontWeight: '600', color: '#173C50' }}>{MOBILE_TITLE}</div>
                    </div>
                    <div style={{ marginTop: '10px', fontSize: '13px', fontWeight: '400', color: '#173C50', lineHeight: '19px', textAlign: 'left' }}>{MOBILE_SHORT}</div>
                </div>

                {/* Formulaire */}
                <div style={{ marginTop: '30px', display: 'flex', flexDirection: 'column', width: '100%' }}>
                    {step === 0 ? (
                        <>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
                                {textField(prenom, setPrenom, 'Prénom')}
                                {textField(nom, setNom, 'Nom')}
                                {textField(email, setEmail, 'Entrez votre adresse mail', 'email')}
                            </div>
                            <div style={{ marginTop: '10px' }}>{suivantBtn}</div>
                        </>
                    ) : (
                        <>
                            {passwordField}
                            <div style={{ marginTop: '10px' }}>{rulesList}</div>
                            <div style={{ marginTop: '10px' }}>{confirmCombo}</div>
                            <div style={{ marginTop: '20px' }}>{cguRow}</div>
                            <div style={{ marginTop: '11px' }}>{newsletterRow}</div>
                            <div style={{ marginTop: '19px' }}>{cestPartiBtn}</div>
                        </>
                    )}
                </div>

                {/* Retour en bas */}
                <div style={{ marginTop: 'auto', paddingTop: '20px', display: 'flex', justifyContent: 'flex-start', flexShrink: 0 }}>
                    {backLink}
                </div>
            </form>
        );
    }

    // --- Rendu desktop (700×540) ---
    return (
        <div style={{
            width: '700px',
            height: '540px',
            display: 'flex',
            overflow: 'hidden',
            borderRadius: '20px',
            boxShadow: '0px 10px 40px rgba(0, 0, 0, 0.1)',
        }}>
            {/* Panneau gauche */}
            <div style={{
                height: '100%',
                width: '360px',
                backgroundColor: '#173C50',
                position: 'relative',
                color: '#FFFFFF',
                flexShrink: 0,
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '15px',
                    paddingLeft: '30px',
                    left: '0',
                    position: 'absolute',
                    top: error ? '74px' : '36px',
                    transition: 'top 0.1s ease',
                }}>
                    <div style={{ fontSize: '24px', fontWeight: '600' }}>{istorContent.title}</div>
                    <div style={{ whiteSpace: 'pre-line', fontSize: '13px', fontWeight: '400', lineHeight: '19px' }}>{istorContent.message}</div>
                </div>
                <img style={{ position: 'absolute', bottom: 0, right: '-20px', width: '325px', height: '260px' }} src={istor} alt="istor" />
            </div>

            {/* Panneau droit */}
            <form
                onSubmit={handleSubmit}
                style={{
                    width: '340px',
                    height: '100%',
                    backgroundColor: '#FFFFFF',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '20px 35px 35px 35px',
                    boxSizing: 'border-box',
                }}
            >
                {/* Retour : « Revenir à la connexion » (étape 1) / « Retour » (étape 2) */}
                <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexShrink: 0 }}>
                    {backLink}
                </div>

                {step === 0 ? (
                    /* Étape 1 : identité */
                    <div style={{ marginTop: '139px', display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
                        {textField(prenom, setPrenom, 'Prénom')}
                        {textField(nom, setNom, 'Nom')}
                        {textField(email, setEmail, 'Entrez votre adresse mail', 'email')}
                        {suivantBtn}
                    </div>
                ) : (
                    /* Étape 2 : mot de passe */
                    <div style={{ marginTop: '139px', display: 'flex', flexDirection: 'column', width: '100%' }}>
                        {passwordField}
                        <div style={{ marginTop: '10px' }}>{rulesList}</div>
                        <div style={{ marginTop: '10px' }}>{confirmCombo}</div>
                        <div style={{ marginTop: '37px' }}>{cguRow}</div>
                        <div style={{ marginTop: '11px' }}>{newsletterRow}</div>
                        <div style={{ marginTop: '19px' }}>{cestPartiBtn}</div>
                    </div>
                )}
            </form>
        </div>
    );
};

export default Register;
